import { useTranslation } from 'react-i18next'

import { IconRequestSent } from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'
import AvatarHolder from 'components/UI/AvatarHolder/AvatarHolder'
import { useModalContext } from 'context/modalContext'

import { type FriendRequestModalProps } from '../FriendRequestModal'

import './FriendshipRequestSentModal.scss'

type FriendRequestSentModalProps = Pick<FriendRequestModalProps, 'avatar' | 'message'>

export const FriendRequestSentModal = (props: FriendRequestSentModalProps) => {
    const { avatar, message } = props
    const { clearModal } = useModalContext()
    const { t } = useTranslation()

    return (
        <div>
            <div className='friendReqSentModal__user'>
                <div className='avatar'>
                    <AvatarHolder img={avatar ?? ''} size='80' />
                    <IconRequestSent />
                </div>
                <p>{message || t('yourFriendRequestHasBeenSent')}</p>
                <Button
                    color='black'
                    height='3'
                    font='mont-14-normal'
                    text={t('close')}
                    customClass={'friendReqSentModalButton'}
                    clickFn={clearModal}
                />
            </div>
        </div>
    )
}
